export enum DeliveryMethod {
  ComeToMe = 'ComeToMe',
  MailIn = 'MailIn',
  VisitStore = 'VisitStore',
}
